import { render } from "./customizeMultiSubOption.vue?vue&type=template&id=bc8b9e38&scoped=true"
import script from "./customizeMultiSubOption.vue?vue&type=script&lang=js"
export * from "./customizeMultiSubOption.vue?vue&type=script&lang=js"

import "./customizeMultiSubOption.vue?vue&type=style&index=0&id=bc8b9e38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8b9e38"]])

export default __exports__